import React, { useEffect, useState } from 'react';
import { View, Text, Linking, StyleProp, TextStyle } from 'react-native';
import { DynamicLinkTextProps } from '../../Types/ControlTypes';
import { LinkTextConfig } from '../../Types/ControlConfigTypes';

const DynamicLinkText = (props: DynamicLinkTextProps): React.ReactElement => {
  const [textStyle, setTextStyle] = useState<StyleProp<TextStyle>>({});

  useEffect(() => {
    if (props.config) setTextStyle(getTextStyle(props.config));
  }, []);

  const getTextStyle = (config: LinkTextConfig): StyleProp<TextStyle> => {
    let style: StyleProp<TextStyle> = {};

    try {
      if (config.color) style.color = config.color;

      if (config.fontFamily) style.fontFamily = config.fontFamily;

      if (config.fontSize) style.fontSize = config.fontSize;

      if (config.fontWeight) style.fontWeight = config.fontWeight;

      if (config.paddingTop) style.paddingTop = config.paddingTop;
      else style.paddingTop = 6;

      if (config.paddingBottom) style.paddingBottom = config.paddingBottom;
      else style.paddingBottom = 6;

      if (config.letterSpacing) style.letterSpacing = config.letterSpacing;
    } catch (error) {}

    return style;
  };

  const goToRef = () => {
    const href = props.config?.href;
    if (href) Linking.openURL(href);
  };

  return (
    <View style={{ display: props.visible === false ? 'none' : 'flex' }}>
      <Text>
        <Text style={textStyle}>
          {props.config?.preText ? props.config?.preText + ' ' : ''}
        </Text>
        <Text
          style={[textStyle, { textDecorationLine: 'underline' }]}
          onPress={() => goToRef()}>
          {props.config?.linkText ?? ''}
        </Text>
        <Text style={textStyle}>
          {props.config?.postText ? ' ' + props.config?.postText : ''}
        </Text>
      </Text>
    </View>
  );
};

export default DynamicLinkText;
